export default __webpack_public_path__ + "media/images/centre-onglet-a9df7f146ca7f4eb9ce803b3ea7680f5.png";